import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from '../fragments/COMPONENT_COLORS_AND_SIZES';
const SET_VARIANT_SIZE_FOR_ALL_SPECIFICATION_SIZES = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  mutation SetVariantSizeForAllSpecificationSizes($componentId: ID!, $productVariantSize: String!) {
    setVariantSizeForAllSpecificationSizes(
      componentId: $componentId
      productVariantSize: $productVariantSize
    ) {
      component {
        id
        variantSizeForAllSpecificationSizes
        ...ComponentColorsAndSizesFragment
      }
    }
  }
`;
export default SET_VARIANT_SIZE_FOR_ALL_SPECIFICATION_SIZES;
